import cn from 'classnames';
import { useConfig } from 'config/use-config';
import { FormattedMessage } from 'react-intl';
import { formatPhoneNumber } from 'utils/phone';
import IconPhone from '../../assets/icons/phone.svg';

interface Props {
  showMobile?: boolean;
  showDesktop?: boolean;
}

/**
 * Component used by the checkout form to show the user the customer service contact.
 */
const CustomerServiceInfo: React.FC<Props> = ({ showMobile = false, showDesktop = false }) => {
  const { customerHotline } = useConfig();

  return (
    <div
      className={cn(
        'text-grey-700 mt-4 flex flex-col items-center justify-center p-6',
        { 'lg:hidden': showMobile },
        { 'hidden lg:block': showDesktop }
      )}
    >
      <h3 className="text-primary-main text-center text-xl font-black lg:text-left">
        <FormattedMessage id="funnel:cart-box:questions" />
      </h3>
      <p>
        <FormattedMessage id="funnel:cart-box:call" />
      </p>
      <div className="mt-4 flex">
        <div className="flex items-center pr-3">
          <IconPhone className="h-5 w-5 rotate-90 transform opacity-90" />
        </div>
        <div>
          <p className="text-lg">
            <FormattedMessage
              id="funnel:cart-box:phone-number"
              values={{ phone: formatPhoneNumber(customerHotline) }}
            />
          </p>
          <p className="text-text-light-bg-secondary text-sm">
            <FormattedMessage id="funnel:cart-box:opening-hours" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerServiceInfo;
